import React from 'react';
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  // Link,
  useToast,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
// import DefaultAuth from "layouts/auth/Default";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import { RiEyeCloseLine } from 'react-icons/ri';
import Card from '../../../components/card/Card';
import Cookies from 'js-cookie';

import axiosInstance from 'api/axiosInstance';
import apiUrls from 'api/apiUrls';
const BASE_URL = process.env.REACT_APP_DGPV_API_URL;

function SignIn() {
  const [data, setData] = React.useState({ email: '', password: '' });
  const [show, setShow] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const navigate = useNavigate();
  const toast = useToast();

  const onChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClick = () => setShow(!show);

  const handleAuth = (e) => {
    e.preventDefault();
    handleLogin({
      username: data.email,
      password: data.password,
    });
  };

  const handleLogin = async (loginData) => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.post(apiUrls.login, loginData);
      const result = await response.data;

      // Save tokens in cookies instead of localStorage
      Cookies.set('authToken', result.token, {
        secure: false,
        sameSite: 'strict',
      });
      Cookies.set('refreshToken', result.refreshToken, {
        secure: false,
        sameSite: 'strict',
      });

      const resp = await axiosInstance.post(apiUrls.getAccessToken, {
        platform_url: BASE_URL,
      });
      Cookies.set('UGXAuthorization', resp.data.access_token, {
        secure: false,
        sameSite: 'strict',
      });
      toast({
        title: 'Login successful',
        description: 'You have successfully logged in.',
        status: 'success',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      navigate('/dashboard', { replace: true });
    } catch (error) {
      const { status, message } = error?.response.data || {};
      if (status === 401) {
        toast({
          title: 'Invalid credentials',
          description: `${message || 'Please check your email and password and try again.'}`,
          status: 'error',
          duration: 3000,
          position: 'top',
          isClosable: true,
        });
      } else {
        toast({
          title: 'Login error',
          description: `${message || 'An error occurred during login. Please try again later.'}`,
          status: 'error',
          duration: 3000,
          position: 'top',
          isClosable: true,
        });
        // toast.error('An error occurred during login. Please try again later.');
      }
      // toast.error(error.message || 'An error occurred during login');
    } finally {
      setIsLoading(false);
    }
  };

  // UI Colors & Theme
  const textColor = useColorModeValue('navy.800', 'white');
  const textColorSecondary = useColorModeValue('gray.500', 'navy.400');
  const brandStars = useColorModeValue('brand.500', 'brand.400');
  const inputFocusBorder = useColorModeValue('brand.500', 'brand.300');
  const cardBg = useColorModeValue('white', 'navy.700');
  const cardShadow = useColorModeValue(
    '0 12px 32px rgba(0, 0, 0, 0.12)',
    '0 12px 32px rgba(0, 0, 0, 0.6)',
  );
  const buttonHoverBg = useColorModeValue('brand.600', 'brand.300');

  const handleEnterKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleAuth(e);
    }
  };

  return (
    // <DefaultAuth>
    <>
      <Flex
        h="100vh"
        w="100%"
        align="center"
        justify="center"
        px={{ base: '4', md: '12' }}
        // bgGradient="linear(to-r, blue.50, white)"
      >
        <Card
          bg={cardBg}
          boxShadow={cardShadow}
          w={{ base: '100%', md: '600px' }}
          p={{ base: 8, md: 12 }}
          borderRadius="20px"
        >
          <Box mb={10}>
            <Heading
              color={textColor}
              fontSize={{ base: '2xl', md: '3xl' }}
              mb="6"
            >
              Sign In
            </Heading>
            <Text color={textColorSecondary} fontSize="lg">
              Sign in to access your dashboard
            </Text>
          </Box>

          {/* Email */}
          <FormControl isRequired mb="6">
            <FormLabel fontWeight="600" fontSize="md" color={textColor}>
              Email{' '}
              <Text as="span" color={brandStars}>
                *
              </Text>
            </FormLabel>
            <Input
              name="email"
              type="email"
              size="lg"
              placeholder="you@example.com"
              value={data.email}
              onChange={onChange}
              autoComplete="email"
              _focus={{ borderColor: inputFocusBorder }}
              onKeyDown={handleEnterKeyPress}
            />
          </FormControl>

          {/* Password */}
          <FormControl isRequired mb="4">
            <FormLabel fontWeight="600" fontSize="md" color={textColor}>
              Password{' '}
              <Text as="span" color={brandStars}>
                *
              </Text>
            </FormLabel>
            <InputGroup size="lg">
              <Input
                name="password"
                placeholder="********"
                type={show ? 'text' : 'password'}
                onKeyDown={handleEnterKeyPress}
                value={data.password}
                onChange={onChange}
                autoComplete="current-password"
                _focus={{ borderColor: inputFocusBorder }}
              />
              <InputRightElement h="full" display="flex" alignItems="center">
                <Icon
                  as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                  onClick={handleClick}
                  cursor="pointer"
                  color={textColorSecondary}
                />
              </InputRightElement>
            </InputGroup>
          </FormControl>

          {/* Forgot Password */}
          {/* <Flex justify="flex-end" mb="6">
            <Link fontSize="sm" color={brandStars} _hover={{ textDecoration: "underline" }}>
              Forgot password?
            </Link>
          </Flex> */}

          {/* Submit Button */}
          <Button
            w="100%"
            size="lg"
            fontWeight="700"
            color="white"
            bg="brand.500"
            _hover={{ bg: buttonHoverBg }}
            onClick={handleAuth}
            isLoading={isLoading}
            loadingText="Signing in..."
          >
            Sign In
          </Button>
        </Card>
      </Flex>
    </>
  );
}

export default SignIn;
